module.exports = __webpack_public_path__ + "static/media/interactive.c6d9af04.png";